import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

// Redirect to the unified LegalPage component with the CGV slug
const CGVPage = () => {
  return <Navigate to="/site/legal/cgv" replace />;
};

export default CGVPage;
